// Note: do not mix this export with other app-only logic
// to avoid importing unnecessary code in the plugins.
export const DEFAULT_LOCALE = 'en-us';
